// extracted by mini-css-extract-plugin
export default {"checkboxContainer":"CheckboxContainer_checkboxContainer__oIjKx"};